import { useAppSelector } from '@pkg/hooks';
type UseIsWishlistOwnerProps = {
    ownerId?: string;
};
export const useIsWishlistOwner = ({ ownerId }: UseIsWishlistOwnerProps): boolean => {
    const userAccount = useAppSelector((state) => state.user.userAccount);
    return Boolean(userAccount && userAccount.user.id === ownerId);
};
